module.exports = __webpack_public_path__ + "static/media/TW-GerardRoss-tablet-738x57.13c7da2b.jpg";